// Hydration loading wrapper for license store
'use client';

import { LoadingIndicator } from '@koda/koda-components/atoms/Button';
import { useLicenseStore } from '../licenseStore';

const StoreLoadingState = ({ children }: { children: React.ReactNode }) => {
  const isHydrated = useLicenseStore(state => state.isHydrated);
  return (
    <div className="relative">
      <div className={`transition-all ${isHydrated ? 'opacity-100' : 'animate-pulse opacity-10'}`}>{children}</div>
      <div className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center">
        <div
          className={`animate-spin transition-all ${isHydrated ? 'opacity-0' : 'opacity-100'} size-6`}
          aria-hidden={isHydrated}
        >
          <LoadingIndicator variant="primaryLight" />
        </div>
      </div>
    </div>
  );
};

export default StoreLoadingState;
